import CreatorRevenueChartComponent from "./CreatorRevenueChartComponent";

export default CreatorRevenueChartComponent;
